// extracted by mini-css-extract-plugin
export default {"wrapper":"VGQRbr","container":"jFX22S"};